// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-box {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: #333547;\r\n\tposition: absolute;\r\n\ttext-align: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
